function getDescriptionState(state) {
  return {
    formValues: {
      title:
        state.stepDescriptionProf.formValues?.title === 'GENERIC_TITLE'
          ? ''
          : state.stepDescriptionProf.formValues?.title,
      description:
        state.stepDescriptionProf.formValues?.description === 'GENERIC_DESCRIPTION'
          ? ''
          : state.stepDescriptionProf.formValues?.description,
      code: state.stepDescriptionProf.formValues?.code,
      titleAI: state.stepDescriptionProf.formValues?.titleAI,
      descriptionAI: state.stepDescriptionProf.formValues?.descriptionAI
    },
    formValuesError: state.stepDescriptionProf.formValuesError,
    formValuesLoading: state.stepDescriptionProf.formValuesLoading,
    formValuesCompleted: state.stepDescriptionProf.formValuesCompleted,
    suggestedDataError: state.stepDescriptionProf.suggestedDataError,
    suggestedDataLoading: state.stepDescriptionProf.suggestedDataLoading,
    suggestedDataCompleted: state.stepDescriptionProf.suggestedDataCompleted
  };
}

export { getDescriptionState };
